import { isContractPartyAdmin, isHubAdmin } from './networkMode.js';

export const PARTY_LINKED_ROLES = ['Agent', 'Contract Party Admin'];

const COMPANY_USER_MANAGER_ROLES = [
  'Admin',
  'Accountant',
  'Agent',
  'Driver',
  'Contract Party Admin',
  'Hub Admin',
  'Staff',
];

/** Roles the current user may assign when creating or editing users. */
export function filterCreatableRoles(allRoles, currentUser) {
  if (!Array.isArray(allRoles) || !currentUser) {
    return allRoles || [];
  }

  if (isContractPartyAdmin(currentUser) || isHubAdmin(currentUser)) {
    return allRoles.filter((role) => role.role_name === 'Agent');
  }

  if (currentUser.role === 'System Admin') {
    return allRoles.filter((role) => role.role_name !== 'Owner');
  }

  if (currentUser.role === 'Admin' || currentUser.role === 'Accountant') {
    const isInternal = currentUser.network_mode !== 'EXTERNAL';
    return allRoles.filter((role) => {
      if (role.role_name === 'Owner') {
        return currentUser.role === 'Admin';
      }
      if (!COMPANY_USER_MANAGER_ROLES.includes(role.role_name)) {
        return false;
      }
      // Hub Admin only for internal network companies
      if (role.role_name === 'Hub Admin' && !isInternal) {
        return false;
      }
      return true;
    });
  }

  return allRoles.filter((role) => role.role_name !== 'Owner');
}

export function showUserPartyLabel(roleName) {
  return PARTY_LINKED_ROLES.includes(roleName);
}

export function getUserPartyLabel(user) {
  if (!user || !showUserPartyLabel(user.role_name)) {
    return null;
  }
  if (user.role_name === 'Agent') {
    return user.party_name || 'Own Company';
  }
  return user.party_name || '—';
}

/** Keep the user's existing role visible on edit even if not assignable. */
export function ensureRoleInList(roles, roleId, allRoles) {
  if (roleId == null) {
    return roles;
  }
  const currentRole = allRoles.find((role) => role.id === roleId);
  if (currentRole && !roles.some((role) => role.id === currentRole.id)) {
    return [currentRole, ...roles];
  }
  return roles;
}
